/**
 * 10 Oct — THE FLEET'S TABS. Cylinders, Filling, Yard, Damage & quarantine, Identity and
 * Labels are six places for one asset; the redesign puts them under Cylinders as tabs.
 * Each screen keeps its own file and contract; this strip is the second level the rail
 * no longer has to be.
 */
import * as React from 'react';
import { go } from './hooks.js';
import { can, type Session } from './api.js';
import { SCREENS } from '../../src/screens/contracts.js';

const TABS: { id: string; label: string }[] = [
  { id: 'cylinders', label: 'Register' }, { id: 'filling', label: 'Filling' }, { id: 'yard', label: 'Yard, damage & quarantine' },
  { id: 'identity', label: 'Identity' }, { id: 'labels', label: 'Labels' },
];

export function FleetTabs({ active, session }: { active: string; session: Session }) {
  const shown = TABS.filter((t) => { const s = SCREENS.find((x) => x.id === t.id); return !s?.requires || can(session, s.requires); });
  if (shown.length <= 1) return null;
  return (
    <div className="fleet-tabs" role="tablist" aria-label="The fleet">
      {shown.map((t) => (
        <button type="button" key={t.id} role="tab" aria-selected={active === t.id} className={`fleet-tab${active === t.id ? ' on' : ''}`}
                onClick={() => { if (active !== t.id) go(`#/${t.id}`); }}>{t.label}</button>
      ))}
    </div>
  );
}
